var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-modal",class:_vm.classes},[_c('div',{staticClass:"uk-modal-dialog"},[(_vm.opened)?[_vm._t("default")]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }